// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Portal_ClientesInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /customer-portal/v1/clientes
 *
 * Validates the canonical documento query parameter used to resolve
 * cliente records across all franchises.
 *
 * The documento must already be normalized (uppercase [A-Z0-9]) before
 * reaching this contract. The controller is responsible for calling
 * normalizeDocumento() on the raw input first, then passing the
 * canonical value into fill().
 */
import { registerContract } from './validate'

export interface Portal_ClientesInput {
documento: string
}

registerContract('Portal_ClientesInput', {
  documento: { type: 'string',  required: true },
})
